import React from 'react';
import { useApp } from '../../context/AppContext';

export default function NavBar() {
  const { activeWorld, bizTab, setBizTab, conTab, setConTab, contentPieces, ideas } = useApp();

  const studioBadge = contentPieces.filter(p => p.status === 'draft').length;
  const ideasBadge  = ideas.filter(i => i.status === 'new').length;

  if (activeWorld === 'set') return <div className="nav" />;

  if (activeWorld === 'biz') return (
    <nav className="nav">
      <button className={`mtab ${bizTab === 'ideas'    ? 'active' : ''}`} onClick={() => setBizTab('ideas')}>
        💡 Idea Lab
        {ideasBadge > 0 && <span className="tab-badge">{ideasBadge}</span>}
      </button>
      <button className={`mtab ${bizTab === 'studio'   ? 'active' : ''}`} onClick={() => setBizTab('studio')}>
        ✍️ Content Studio
        {studioBadge > 0 && <span className="tab-badge green">{studioBadge}</span>}
      </button>
      <button className={`mtab ${bizTab === 'calendar' ? 'active' : ''}`} onClick={() => setBizTab('calendar')}>
        📅 Calendar
      </button>
      <div className="nav-fill" />
    </nav>
  );

  if (activeWorld === 'con') return (
    <nav className="nav">
      <button className={`mtab ${conTab === 'con-ideas'    ? 'active' : ''}`} onClick={() => setConTab('con-ideas')}>
        💡 Ideas
      </button>
      <button className={`mtab ${conTab === 'con-create'   ? 'active' : ''}`} onClick={() => setConTab('con-create')}>
        ✨ Create
      </button>
      <button className={`mtab ${conTab === 'con-calendar' ? 'active' : ''}`} onClick={() => setConTab('con-calendar')}>
        📅 Calendar
      </button>
      <button className={`mtab ${conTab === 'con-blog'     ? 'active' : ''}`} onClick={() => setConTab('con-blog')}>
        📝 Blog Posts
      </button>
      <div className="nav-fill" />
    </nav>
  );

  return null;
}
